/** LinkedIn profile visits: the timeframe picker (extracted from en.ts to keep it shrinking). */
export const enLiProfileVisits = {
	DAYS14: "14 days",
	DAYS28: "28 days",
	DAYS90: "90 days",
	DAYS365: "365 days",
	profile: "Profile",
	timeframe: "Profile views since",
};
